export const DYNAMIC_PROCESSES_LIST_PATH = "/settings-menu/dynamic-processes";
